'use client';
import { useEffect, useState } from 'react';
import AppButton from '../AppButton';
import AppDialog from '../AppDialog';
import './style.css';

interface IAppAlert {
  title?: 'Sucesso' | 'Erro' | 'Atenção' | 'Aviso';
  message?: string;
  onClose?: () => void;
  onConfirm: () => void;
  className?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

const AppAlert = ({ title, message, onClose, onConfirm, className, confirmLabel = 'Ok', cancelLabel = 'Cancelar' }: IAppAlert) => {
  const [open, setOpen] = useState(title ? true : false);

  useEffect(() => {
    setOpen(title ? true : false);
  }, [title]);

  if (!open) return null;

  const newHeader = () => {
    const getHeaderClass = () => {
      switch (title) {
        case 'Sucesso': return 'success';
        case 'Erro': return 'error';
        case 'Atenção': return 'warning';
        default: return 'info';
      }
    };

    return (
      <div className={`app-alert-header ${getHeaderClass()}`}>
        <h4>{title}</h4>
      </div>
    );
  };

  const getContentClass = () => {
    switch (title) {
      case 'Sucesso': return 'custom_alert_success';
      case 'Erro': return 'custom_alert_error';
      case 'Atenção': return 'custom_alert_warning';
      default: return 'custom_alert_info';
    }
  };

  return (
    <AppDialog
      maskClassName={`custom_dialog_master p-4`}
      header={title}
      visible={open}
      onHide={() => {
        if (onClose) {
          onClose();
          return;
        }
        onConfirm();
      }}
      className={`custom_dialog_master app-alert ${className || ''}`}
      contentClassName={getContentClass()}
      headerClassName={getContentClass()}
      closable={false}
      draggable={false}
    >
      <div className="app-alert-content">
        <p>{message}</p>
        <div className="app-alert-actions">
          {onClose && <AppButton label={cancelLabel} className="app-alert-cancel-btn" onClick={onClose} />}
          <AppButton label={confirmLabel} className="app-alert-confirm-btn" onClick={onConfirm} />
        </div>
      </div>
    </AppDialog>
  );
};

export default AppAlert;
